import React, { useState, useEffect } from 'react';
import Api from '../../../api/global.service';
import BlockUi from 'react-block-ui';
import useEtiquetas from '../../../hooks/useEtiquetas';
import transformWord from '../../../utils/transformWord';
import { isMiel } from '../../../components/content/coop-config';

const ParcelasResumenTotalesHas = ({ id_ciclo }) => {
  const [data, setData] = useState([]);
  const [blocking, setBlocking] = useState(true);
  const [dataFicha, setDataFicha] = useState(0);
  const { etiquetas } = useEtiquetas();


  useEffect(() => {
    if (id_ciclo > 0) {
      getData();
    }
  }, [id_ciclo]);

  const getData = () => {
    setBlocking(true);
    Api.search('dashboards/parcelas/totales', {
      filter: [{ column: 'id_ciclo', operator: '=', value: id_ciclo }],
    }).then(response => {
      setData(response.data);
      if (!isNaN(response.data[0]?.parcelas_totales)) {
        setDataFicha(response.data[0]?.parcelas_totales ?? 0);
      }
      setBlocking(false);
      // Set initial value
      // eslint-disable-next-line eqeqeq
    });
  };

  return (
    <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
      {!isMiel() && (
      <div className="row">
        <div className="col-4">
          <div className="col-xl-12 col-md-12">
            <div className="row p-10 mt-2">
              <div className="col-xl-9 col-md-9 p-1">
                <div className="font-lato-normal-400" style={{ fontSize: 14, paddingHorizontal: 0 }}>
                  {transformWord(etiquetas?.parcela, ['plural','capitalize'])} con ficha
                </div>
                <div className="font-lato-normal-600" style={{ fontSize: 32 }}>
                  {dataFicha.toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

          <div className="col-4">
          <div className="col-xl-12 col-md-12">
            <div className="row p-10 mt-2">
              <div className="col-xl-9 col-md-9 p-1">
                <div className="font-lato-normal-400" style={{ fontSize: 14, paddingHorizontal: 0 }}>
                  Hectáreas de café
                </div>
                <div className="font-lato-normal-600" style={{ fontSize: 32 }}>
                  {Number(data[0]?.total_has_cafe || 0).toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

          <div className="col-4">
          <div className="col-xl-12 col-md-12">
            <div className="row p-10 mt-2">
              <div className="col-xl-9 col-md-9 p-1">
                <div className="font-lato-normal-400" style={{ fontSize: 14, paddingHorizontal: 0 }}>
                  Hectáreas promedio
                </div>
                <div className="font-lato-normal-600" style={{ fontSize: 32 }}>
                  {data[0]?.promedio_has_cafe.toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
    
      </div>
          )}
    </BlockUi>
  );
};

export default ParcelasResumenTotalesHas;
